var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"row notFound"},[_c('div',{staticClass:"lg-2"}),_c('div',{staticClass:"lg-10 text-right text"},[_c('h1',[_vm._v("404 "+_vm._s(_vm.translation.serverError.notFound))])])])}
var staticRenderFns = []

export { render, staticRenderFns }